import React, { Component } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
// This is How useContext API works

// first we will make a new context
export const CrfContext = React.createContext();

// Then create a provider Component
export default class CrfProvider extends Component {
  state = {
    btn1List: false,
    btn2List: false,
    testState: "Test!",
    login: false,
    userRole: "",
    userName: "",
    userFullName: "",
    userDepartment: [],
    userId: "",
    userEmail: "",

    cocExpenses: [],
    advances: [],
    ppeAccounts: [],
    adminExpenses: [],
    advancesProjectClass: [],
  };

  componentDidMount() {
    if (localStorage.token) {
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          //   
          this.setState({
            userRole: response.data.data.roles[0],
            userName:
              response.data.data.firstName + " " + response.data.data.lastName,
            userDepartment: response.data.data.departments,
            userId: response.data.data._id,
            userEmail: response.data.data.email,
            // userFullName: response
          });
        })
        .catch((error) => {
          //   
          localStorage.removeItem("token");
          window.location.reload();
        });
    }

    // ===================================================================================================================================
  }

  render() {
    //   

    const stateArray = [];
    for (let key in this.state.projectClass) {
      stateArray.push(key);
    }

    if (this.state.btn1List === true) {
      document.getElementById("request-btn").style.paddingBottom = "0px";
    }

    const test = "Test";
    //   
    return (
      <CrfContext.Provider
        value={{
          state: this.state,
          test: this.state.userDepartment,

          toggleBtn1List: (e) => {
            e.preventDefault();
            this.setState({ btn1List: !this.state.btn1List, btn2List: false });
            // document.getElementById('check-btn').style.paddingBottom = '35px';
            // document.getElementById('request-btn').style.paddingBottom = '0px';
            if (this.state.btn1List === false) {
              document.getElementById("request-btn").style.paddingBottom =
                "0px";
            } else {
              document.getElementById("request-btn").style.paddingBottom =
                "35px";
            }
          },

          toggleBtn2List: () => {
            this.setState({ btn2List: !this.state.btn2List, btn1List: false });
            document.getElementById("request-btn").style.paddingBottom = "35px";
            document.getElementById("check-btn").style.paddingBottom = "35px";
          },

          // toggleBtn2List: () => {
          //   this.setState({ btn2List: !this.state.btn2List, btn1List: false });
          //   document.getElementById("navlist2").style.height = "auto";
          //   document.getElementById("navlist2").style.transition = "0.5s";
          //   document.getElementById("navLink1Asset").style.display = "block";
          //   document.getElementById("navLink2Asset").style.display = "none";
          //   if (this.state.btn2List === true) {
          //     document.getElementById("navlist2").style.height = "60px";
          //     document.getElementById("navLink2Asset").style.display = "block";
          //   }
          // }
        }}
      >
        {this.props.children}
      </CrfContext.Provider>
    );
  }
}
